import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import NgwaahiaIcon from "../../common-components/NgwaahiaIcon";
import {
  APP_SCHEME,
  IOS_STORE_URL,
  ANDROID_STORE_URL,
} from "../../utility/constants";

// Universal-link fallback for mobile-only screens (verify-phone, setup-shop, etc.)
// that have no web equivalent. When the app is installed, iOS/Android intercept
// the request before it ever reaches this page. This only renders when it doesn't
// (app not installed, desktop browser, or the OS hasn't verified the association yet).
const OpenInApp = () => {
  const location = useLocation();
  const deepLink = `${APP_SCHEME}://${location.pathname.slice(1)}${location.search}`;

  useEffect(() => {
    window.location.href = deepLink;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        bgcolor: "#f0f7fa",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          bgcolor: "white",
          borderRadius: 4,
          p: 5,
          maxWidth: 360,
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <NgwaahiaIcon size={56} color="#046287" />
        </Box>
        <Typography variant="h6" fontWeight={700} color="#046287" sx={{ mb: 1 }}>
          Ngwaahia
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          Opening the app&hellip;
        </Typography>
        <Button
          fullWidth
          variant="contained"
          size="large"
          href={deepLink}
          sx={{
            bgcolor: "#046287",
            "&:hover": { bgcolor: "#035070" },
            borderRadius: 50,
            fontWeight: 700,
            mb: 2.5,
          }}
        >
          Open in App
        </Button>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <Typography
            component="a"
            href={IOS_STORE_URL}
            variant="body2"
            sx={{ color: "#046287", textDecoration: "underline" }}
          >
            App Store
          </Typography>
          <Typography
            component="a"
            href={ANDROID_STORE_URL}
            variant="body2"
            sx={{ color: "#046287", textDecoration: "underline" }}
          >
            Google Play
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OpenInApp;
